/**
 * 视图层公共接口。
 * 正常模式与摸鱼模式都需要实现这些方法，App 只依赖接口而非具体 DOM 结构。
 */
export class ViewInterface {
  /**
   * @param {HTMLElement} container - 视图挂载的根容器
   */
  constructor(container) {
    this.container = container;
    this.callbacks = {};
  }

  /**
   * 设置用户交互回调。
   * @param {Object} callbacks
   */
  setCallbacks(callbacks) {
    this.callbacks = { ...this.callbacks, ...callbacks };
  }

  /** 初始化视图，绑定 DOM 事件。 */
  init() {
    throw new Error('init() must be implemented');
  }

  /**
   * 根据当前游戏状态和配置渲染整个视图。
   * @param {Object} state - gameState.get() 返回的状态
   * @param {Object} config - 当前配置
   */
  render(state, config) {
    throw new Error('render() must be implemented');
  }

  /**
   * 设置加载状态（禁用/启用输入）。
   * @param {boolean} loading
   * @param {Object} state
   */
  setLoading(loading, state) {
    throw new Error('setLoading() must be implemented');
  }

  /** 从 UI 读取设置值。 */
  getSettings() {
    throw new Error('getSettings() must be implemented');
  }

  /**
   * 将配置加载到 UI。
   * @param {Object} config
   */
  setSettings(config) {
    throw new Error('setSettings() must be implemented');
  }

  /**
   * 更新设置摘要展示。
   * @param {Object} config
   */
  updateSettingsSummary(config) {
    throw new Error('updateSettingsSummary() must be implemented');
  }

  /**
   * 显示设置区域消息。
   * @param {string} message
   * @param {'info'|'success'|'error'} type
   */
  showSettingsMessage(message, type = 'info') {
    throw new Error('showSettingsMessage() must be implemented');
  }

  /**
   * 显示游戏区域消息。
   * @param {string} message
   * @param {'info'|'success'|'error'} type
   */
  showGameMessage(message, type = 'info') {
    throw new Error('showGameMessage() must be implemented');
  }

  /** 清空游戏区域消息。 */
  clearGameMessage() {
    throw new Error('clearGameMessage() must be implemented');
  }

  /** 获取提问输入框的值。 */
  getQuestionInput() {
    return '';
  }

  /** 清空提问输入框。 */
  clearQuestionInput() {}

  /** 获取猜测输入框的值。 */
  getGuessInput() {
    return '';
  }

  /** 清空猜测输入框。 */
  clearGuessInput() {}

  /** 获取聊天输入框的值。 */
  getChatInput() {
    return '';
  }

  /** 清空聊天输入框。 */
  clearChatInput() {}
}
